import React from 'react';
import BaseWidget from '../base-widget/BaseWidget';
import LicenseSummary from "../../license/LicenseSummary";
import {WorkbenchStateContext} from "../../context/WorkbenchContext"

class LicenseWidget extends React.Component {

  static contextType = WorkbenchStateContext;

  render() {
    return (
      <BaseWidget className="LicenseWidget" title="License">
        <LicenseSummary license={this.context.license}/>
      </BaseWidget>
    );
  }
}

export default LicenseWidget;
